export const shouldIncludeRowForReturnSelection = ({
  selectedRows,
  returnQuantities,
  index,
}: {
  selectedRows: boolean[];
  returnQuantities: Array<string | number | null | undefined>;
  index: number;
}): boolean => {
  if (selectedRows[index]) return true;
  return Number(returnQuantities[index]) > 0;
};
